import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationBlockSurveyPropertiesConstant {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationBlockSurveyProperties";
    static FUNCTION_IMPORT_PREVIOUS_FINAL_VALUATION = "ImportPreviousFinalValuation";
    static FUNCTION_CHECK_IF_PREVIOUS_FINAL_VALUATION_EXIST = "CheckIfPreviousFinalValuationExist";
    static FUNCTION_IMPORT_FIELD_CARD = "ImportFieldCard";
    static FUNCTION_MARK_ALL_SURVEYS_AS_COMPLETED = "MarkAllSurveysAsCompleted";
}
